import React from "react";
import ContentLoader from "react-content-loader";
import { Card, Row, Col, Divider } from "antd";

const CardSkeleton: React.FC = ({ children }) => (
    <Card className="newUI-raised" style={{ marginBottom: "16px" }}>
        {children}
    </Card>
);

const FormSkeleton = () => (
    <Row gutter={[16, 16]}>
        <Col span={24}>
            <CardSkeleton>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={80}
                    viewBox="0 0 1000 80"
                    backgroundColor="#ffffff"
                    foregroundColor="#ecebeb"
                    preserveAspectRatio="none"
                >
                    {/* Title, Description, Activities */}
                    <rect x="0%" y="0" rx="3" ry="3" width="25%" height="20" />
                    <rect x="33%" y="0" rx="3" ry="3" width="25%" height="20" />
                    <rect x="66%" y="0" rx="3" ry="3" width="25%" height="20" />
                    <rect x="0%" y="30" rx="3" ry="3" width="30%" height="30" />
                    <rect x="33%" y="30" rx="3" ry="3" width="30%" height="30" />
                    <rect x="66%" y="30" rx="3" ry="3" width="30%" height="30" />
                </ContentLoader>
            </CardSkeleton>
        </Col>
        <Col span={24}>
            <Divider />
        </Col>
        <Col span={24}>
            <CardSkeleton>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={60}
                    viewBox="0 0 1000 60"
                    backgroundColor="#ffffff"
                    foregroundColor="#ecebeb"
                    preserveAspectRatio="none"
                >
                    {/* Learning Objectives */}
                    <rect x="0%" y="0" rx="3" ry="3" width="30%" height="20" />
                    <rect x="0%" y="30" rx="3" ry="3" width="100%" height="30" />
                </ContentLoader>
            </CardSkeleton>
        </Col>
        <Col span={24}>
            <Divider />
        </Col>
        <Col span={24}>
            <CardSkeleton>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={60}
                    viewBox="0 0 1000 60"
                    backgroundColor="#ffffff"
                    foregroundColor="#ecebeb"
                    preserveAspectRatio="none"
                >
                    {/* Question */}
                    <rect x="0%" y="0" rx="3" ry="3" width="15%" height="20" />
                    <rect x="20%" y="0" rx="3" ry="3" width="15%" height="20" />
                    <rect x="40%" y="0" rx="3" ry="3" width="15%" height="20" />
                    <rect x="60%" y="0" rx="3" ry="3" width="30%" height="20" />
                    <rect x="0%" y="30" rx="3" ry="3" width="100%" height="30" />
                </ContentLoader>
            </CardSkeleton>
        </Col>
    </Row>
);

export default FormSkeleton;
